/* eslint-disable no-lonely-if */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import React, {
  useContext, useMemo, useEffect, useState,
} from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import {
  Paper, Box, Checkbox, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel,
} from '@mui/material';
import { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import { visuallyHidden } from '@mui/utils';
// import SearchBar from 'material-ui-search-bar';

/* Qlik */
import useQlikSessionObject from 'hooks/useQlikSessionObject';
import AppContext from '../AppContext';

const styles = () => ({
});

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#f9f9f9',
    color: '#7F1431',
    fontSize: 12,
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 13,
  },
}));

function createData(
  name,
  calories,
  fat,
  carbs,
  protein,
) {
  return {
    name,
    calories,
    fat,
    carbs,
    protein,
  };
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: '_team',
    numeric: false,
    disablePadding: false,
    label: ' ',
  },
  {
    id: 'team',
    numeric: false,
    disablePadding: false,
    label: 'Team',
  },
  {
    id: 'winner',
    numeric: true,
    disablePadding: false,
    label: 'Winner',
  },
  {
    id: 'runnerup',
    numeric: true,
    disablePadding: false,
    label: 'Runner-Up',
  },
  {
    id: 'third',
    numeric: true,
    disablePadding: false,
    label: '3rd Place',
  },
  {
    id: 'participations',
    numeric: true,
    disablePadding: false,
    label: 'Participations',
  },
  {
    id: 'gamesplayed',
    numeric: true,
    disablePadding: false,
    label: 'Games Played',
  },
  {
    id: 'won',
    numeric: true,
    disablePadding: false,
    label: 'Won',
  },
  {
    id: 'winrate',
    numeric: false,
    disablePadding: false,
    label: 'Win Rate',
  },
  {
    id: 'goals',
    numeric: true,
    disablePadding: false,
    label: 'Goals',
  },
  {
    id: 'yellowcards',
    numeric: true,
    disablePadding: false,
    label: 'Yellow Cards',
  },
  {
    id: 'redcards',
    numeric: true,
    disablePadding: false,
    label: 'Red Cards',
  },
];

const headPlayerCells = [
  {
    id: '_player',
    numeric: false,
    disablePadding: false,
    label: ' ',
  },
  {
    id: 'player',
    numeric: false,
    disablePadding: false,
    label: 'Player',
  },
  {
    id: 'team',
    numeric: false,
    disablePadding: false,
    label: 'Team',
  },
  {
    id: 'dob',
    numeric: true,
    disablePadding: false,
    label: 'Birth Date',
  },
  {
    id: 'participations',
    numeric: true,
    disablePadding: false,
    label: 'Participations',
  },
  {
    id: 'gamesplayed',
    numeric: true,
    disablePadding: false,
    label: 'Games Played',
  },
  {
    id: 'goals',
    numeric: true,
    disablePadding: false,
    label: 'Goals',
  },
  {
    id: 'goalspergame',
    numeric: true,
    disablePadding: false,
    label: 'Goals per Game',
  },
  {
    id: 'redcards',
    numeric: true,
    disablePadding: false,
    label: 'Red Cards',
  },
  {
    id: 'yellowcards',
    numeric: false,
    disablePadding: false,
    label: 'Yellow Cards',
  },
  {
    id: 'secondyellowcards',
    numeric: true,
    disablePadding: false,
    label: 'Second Yellow Cards',
  },
];

// ************************* ENHANCED TABLE HEAD *********************** //
function EnhancedTableHead(props) {
  const {
    onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, type,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {type === 'team'
          ? headCells.map((headCell) => (
            <StyledTableCell
              key={headCell.id}
              align="left"
              padding={headCell.disablePadding ? 'none' : 'normal'}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </TableSortLabel>
            </StyledTableCell>
          )) : headPlayerCells.map((headCell) => (
            <StyledTableCell
              key={headCell.id}
              align="left"
              padding={headCell.disablePadding ? 'none' : 'normal'}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </TableSortLabel>
            </StyledTableCell>
          ))}
      </TableRow>
    </TableHead>
  );
}
EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
};

// ************************* MUITABLE *********************** //
const MuiTable = ({ qProps, type }) => {
  const qlikApp = useContext(AppContext);

  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('calories');
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);

  const qTableData = useQlikSessionObject({
    app: qlikApp,
    properties: qProps,
  });

  const table = useMemo(() => {
    if (!qTableData.layout) return [];
    let qlikDataWinMatchup = [];
    if (qTableData.layout.qHyperCube.qError) {
      qlikDataWinMatchup = [];
    } else {
      if (qTableData.layout.qHyperCube.qDimensionInfo[0].qFallbackTitle === 'Team') {
        qlikDataWinMatchup = qTableData.layout.qHyperCube.qDataPages[0].qMatrix.map((row) => ({
          qElemNumber: row[0].qElemNumber,
          qState: row[0].qState,
          team: row[0].qText,
          won: row[1].qNum,
          winner: row[2].qNum,
          runnerup: row[3].qText,
          third: row[4].qText,
          participations: row[5].qNum,
          gamesplayed: row[6].qNum,
          winrate: row[7].qText,
          goals: row[8].qNum,
          yellowcards: row[9].qNum,
          redcards: row[10].qNum,
          playerWon: row[1].qAttrExps.qValues[0].qNum,
        }));
      } else {
        qlikDataWinMatchup = qTableData.layout.qHyperCube.qDataPages[0].qMatrix.map((row) => ({
          qElemNumber: row[0].qElemNumber,
          qState: row[0].qState,
          player: row[0].qText,
          dob: row[0].qAttrExps.qValues[0].qText,
          gamesplayed: row[0].qAttrExps.qValues[1].qNum,
          goals: row[0].qAttrExps.qValues[2].qText,
          goalspergame: row[0].qAttrExps.qValues[3].qText,
          redcards: row[0].qAttrExps.qValues[4].qNum,
          yellowcards: row[0].qAttrExps.qValues[5].qNum,
          secondyellowcards: row[0].qAttrExps.qValues[6].qNum,
          participations: row[0].qAttrExps.qValues[7].qNum,
          team: row[0].qAttrExps.qValues[8].qText,
          teamCode: row[0].qAttrExps.qValues[9].qText,
        }));
      }
    }
    return qlikDataWinMatchup;
  }, [qTableData.layout]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = table.map((n) => n.name);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, qElemNumber) => {
    const selectedIndex = selected.indexOf(qElemNumber);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, qElemNumber);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };

  useEffect(() => {
    if (!qTableData.model) return;
    qTableData.model.selectHyperCubeValues('/qHyperCubeDef', 0, selected, false);
  }, [selected]);

  useEffect(() => {
    if (!qTableData.model) return;
    const motherSelections = qTableData.layout.qHyperCube.qDataPages[0].qMatrix.filter((row) => row[0].qState === 'S').map((row) => row[0].qElemNumber);
    // compare selected state and layout
    if (JSON.stringify(motherSelections) !== JSON.stringify(selected)) {
      setSelected(motherSelections);
    }
  }, [qTableData.layout]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - table.length) : 0;

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const colorTeam = (team) => {
    if (team === 'Brazil') return { bg: '#009739', color: '#FFFFFF' };
    if (team === 'Germany') return { bg: '#000000', color: '#FFFFFF' };
    if (team === 'Argentina') return { bg: '#6CACE4', color: '#FFFFFF' };
    if (team === 'Italy') return { bg: '#007CC3', color: '#FFFFFF' };
    if (team === 'France') return { bg: '#002654', color: '#FFFFFF' };
    if (team === 'Spain') return { bg: '#AA151B', color: '#FFFFFF' };
    if (team === 'Uruguay') return { bg: '#55B5E5', color: '#FFFFFF' };
    if (team === 'England') return { bg: '#CE1124', color: '#FFFFFF' };
    return { bg: '#FFFFFF', color: '#000000' };
  };

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 440 }} style={{ overflow: 'auto' }}>
        <Table
          sx={{ minWidth: 750 }}
          aria-labelledby="tableTitle"
          size="small"
          stickyHeader
        >
          <EnhancedTableHead
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={table.length}
            type={type}
          />
          <TableBody>
            {/* if you don't need to support IE11, you can replace the `stableSort` call with: rows.sort(getComparator(order, orderBy)).slice() */}
            {stableSort(table, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                const isItemSelected = isSelected(row.qElemNumber);
                const labelId = `enhanced-table-checkbox-${index}`;
                return (
                  type === 'team' ? (
                    <TableRow
                      hover
                      onClick={(event) => handleClick(event, row.qElemNumber)}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.team}
                      selected={isItemSelected}
                    >
                      <StyledTableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={isItemSelected}
                          inputProps={{
                            'aria-labelledby': labelId,
                          }}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="left" style={{ backgroundColor: colorTeam(row.team).bg, color: colorTeam(row.team).color }}>{row.team}</StyledTableCell>
                      <StyledTableCell align="left">{row.winner}</StyledTableCell>
                      <StyledTableCell align="left">{row.runnerup}</StyledTableCell>
                      <StyledTableCell align="left">{row.third}</StyledTableCell>
                      <StyledTableCell align="left">{row.participations}</StyledTableCell>
                      <StyledTableCell align="left">{row.gamesplayed}</StyledTableCell>
                      <StyledTableCell align="left">{row.playerWon > 0 ? row.playerWon : row.won}</StyledTableCell>
                      <StyledTableCell align="left">{row.playerWon > 0 ? `${(100 * (row.playerWon / row.gamesplayed)).toFixed(2)}%` : row.winrate}</StyledTableCell>
                      <StyledTableCell align="left">{row.goals}</StyledTableCell>
                      <StyledTableCell align="left">{row.yellowcards}</StyledTableCell>
                      <StyledTableCell align="left">{row.redcards}</StyledTableCell>
                    </TableRow>
                  )
                    : (
                      <TableRow
                        hover
                        onClick={(event) => handleClick(event, row.qElemNumber)}
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={row.player}
                        selected={isItemSelected}
                      >
                        <StyledTableCell padding="checkbox">
                          <Checkbox
                            color="primary"
                            checked={isItemSelected}
                            inputProps={{
                              'aria-labelledby': labelId,
                            }}
                          />
                        </StyledTableCell>
                        <StyledTableCell align="left">{row.player}</StyledTableCell>
                        <StyledTableCell align="left">
                          <img src={`assets/images/st_flags/${row.teamCode}.png`} alt={row.teamCode} style={{ width: '15px', marginRight: '5px' }} />
                          {row.team}
                        </StyledTableCell>
                        <StyledTableCell align="left">{row.dob}</StyledTableCell>
                        <StyledTableCell align="left">{row.participations}</StyledTableCell>
                        <StyledTableCell align="left">{row.gamesplayed}</StyledTableCell>
                        <StyledTableCell align="left">{row.goals}</StyledTableCell>
                        <StyledTableCell align="left">{row.goalspergame}</StyledTableCell>
                        <StyledTableCell align="left">{row.redcards}</StyledTableCell>
                        <StyledTableCell align="left">{row.yellowcards}</StyledTableCell>
                        <StyledTableCell align="left">{row.secondyellowcards}</StyledTableCell>
                      </TableRow>
                    )
                );
              })}
            {emptyRows > 0 && (
              <TableRow
                style={{
                  height: (53) * emptyRows,
                }}
              >
                <TableCell />
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 100]}
        component="div"
        count={table.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>

  );
};

MuiTable.propTypes = {
  qProps: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
};

export default injectSheet(styles)(MuiTable);
